<template>
  <v-layout align-center justify-center>
    <v-card class="elevation-12">
      <v-toolbar color="color.base1" dark>
        <v-toolbar-title>パスワード新規設定</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout>
          <v-flex xs4>
            <h3>所属</h3>
          </v-flex>
          <v-flex xs8 align-self-center>
            <v-progress-circular
              v-if="loadingUser"
              indeterminate
              color="primary"
            />
            <template v-else>
              <ResourceType :value="invitedUser.belongType" />
              <span>{{ invitedUser.belongName }}</span>
            </template>
          </v-flex>
        </v-layout>
        <v-layout pt-2>
          <v-flex xs4>
            <h3>名前</h3>
          </v-flex>
          <v-flex xs8 align-self-center>
            <v-progress-circular
              v-if="loadingUser"
              indeterminate
              color="primary"
            />
            <span v-else>
              <v-text-field
                v-model="invitedUser.name"
                style="padding:0; margin:0;"
                hide-details
              />
            </span>
          </v-flex>
        </v-layout>
        <v-layout pt-2>
          <v-flex xs4>
            <h3>メールアドレス</h3>
          </v-flex>
          <v-flex xs8 align-self-center>
            <v-progress-circular
              v-if="loadingUser"
              indeterminate
              color="primary"
            />
            <span v-else>
              {{ invitedUser.email }}
            </span>
          </v-flex>
        </v-layout>
        <h2 class="pt-4">注意</h2>
        <h3>
          パスワードは、半角英字（大文字・小文字）と数字を含む8文字以上で入力する必要があります。
        </h3>
        <v-text-field
          v-model="invitedUser.password"
          label="新しいパスワード"
          class="mt-4"
          type="password"
        />
        <v-text-field
          v-model="invitedUser.passwordConfirm"
          label="確認"
          type="password"
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <ExecAndCancelButtons
          :can-exec="invitedUser.validation"
          :loading="sending"
          @clickExec="execRegister"
          @clickCancel="displayCancelConfirmModal = true"
          exec-text="送信"
        />
      </v-card-actions>
    </v-card>

    <ConfirmModal
      v-model="displayCancelConfirmModal"
      @clickOk="$router.push('/').catch(() => {})"
      message="ログイン画面に戻ります。よろしいですか？"
    />
    <v-dialog v-model="displayCompleteModal" persistent width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          パスワード設定完了
        </v-card-title>
        <v-card-text>
          パスワードの設定が完了しました。<br />
          再度ログインしてください。
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            @click.prevent="$router.push('/').catch(() => {})"
            dark
            color="color.base1"
            >OK</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import ConfirmModal from '@/components/Shared/CrudUI/ConfirmModal'
import ExecAndCancelButtons from '@/components/Shared/CrudUI/ExecAndCancelButtons.vue'
import { actions as drawerActions } from '@/vuex/modules/ui/drawer/constants'
import ResourceType from '@/components/Shared/Presentation/ResourceType'
import { RegisterAccountForm } from '@/models/Account'

export default {
  components: { ConfirmModal, ExecAndCancelButtons, ResourceType },
  data() {
    return {
      displayCancelConfirmModal: false,
      displayCompleteModal: false,
      sending: false,
      loadingUser: true,
      invitedUser: new RegisterAccountForm(),
    }
  },
  created() {
    this.$store.dispatch(drawerActions.CHANGE_DRAWER_TOGGLE_BUTTON_VISIBILITY, {
      flag: false,
    })
    this.init()
  },
  methods: {
    async init() {
      this.loadingUser = true
      try {
        const result = await RegisterAccountForm.getInvitedUser(
          this.$route.query.token,
        )
        this.invitedUser = new RegisterAccountForm(result)
        this.invitedUser.token = this.$route.query.token
      } catch (e) {
        const result = await this.$confirm('エラー', {
          okText: '閉じる',
          onlyOk: true,
          body: `この招待は無効となっております。
          ご担当者の方に再度招待を依頼してください。
          `,
        })

        if (result) {
          this.$router.push('/').catch(() => {})
        }

        const error = new Error('ユーザー情報の取得に失敗しました。')
        throw error
      }
      this.loadingUser = false
    },
    async execRegister() {
      this.sending = true
      try {
        await this.invitedUser.execRegister()
        this.displayCompleteModal = true
      } catch (e) {
        const error = new Error('パスワードの設定に失敗しました。')
        this.sending = false
        throw error
      }
    },
  },
}
</script>
